import { render, staticRenderFns } from "./QueItem.vue?vue&type=template&id=23184d20&scoped=true"
import script from "./QueItem.vue?vue&type=script&lang=js"
export * from "./QueItem.vue?vue&type=script&lang=js"
import style0 from "./QueItem.vue?vue&type=style&index=0&id=23184d20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23184d20",
  null
  
)

export default component.exports